<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="0"
      controls
      indicators
      background="#ababab"
      img-fluid-grow
      img-center
      style="text-shadow: 1px 1px 2px #333;"
    >
      <b-carousel-slide
        v-for="(item, index) in items"
        :key="index"
        img-width="480"
        img-height="480"
        :caption="item.caption"
        :text="item.text"
        :img-src="item.src"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      slide: 0,
    };
  },
  props: {
    items: {
      require: true,
      type: Array,
      validator: (value) => {
        if (!Array.isArray(value)) return false;

        return !value.some((item) => typeof item !== 'object' || !item.src);
      },
    },
  },
};
</script>
